export const valuesPolyfill = object => {
  return Object.keys(object).map(key => object[key]);
};



// WEBPACK FOOTER //
// ./src/common/polyFills.js